// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3iRSz","left":"InfoRow_left__axasu"};